import { AutocompleteArrayInput, ReferenceArrayInput, required, SimpleForm } from "react-admin";
import { FieldValues } from "react-hook-form";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { validatePlanningTime } from "shared/utils/validations";

export interface InitialFormProps {
  onSubmit: (data: FieldValues) => void;
}

const TestSendingIntitialForm = ({ onSubmit }: InitialFormProps) => {
  return (
    <SimpleForm
      onSubmit={onSubmit}
      sx={{
        "& .MuiStack-root": {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
        },
      }}
    >
      <ReferenceArrayInput
        label="Sites"
        source="siteIds"
        reference={SiteResourcesEnum.Sites}
        filter={{ country: SiteContryEnum.France }}
        perPage={100}
      >
        <AutocompleteArrayInput label="Sites" />
      </ReferenceArrayInput>
      <CustomDateTimeInput source="startDate" validate={[required(), validatePlanningTime]} minDateTime={new Date()} />
    </SimpleForm>
  );
};

export default TestSendingIntitialForm;
